/**
 * Stylish - Custom themes for any website
 *
 * Restyling extension; its userstyle UI is reachable from any page.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 3.4.17.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'fjnbnpbmkenffdnngjfgmeleoegfcffe';
export const stylish: ExtensionDefinition = {
  id: ID,
  name: "Stylish - Custom themes for any website",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 2000000,
  notes: "Restyling extension; its userstyle UI is reachable from any page.",
  signals: [
    { id: 'war-index-html', kind: 'web-accessible-resource',
      description: 'Fetch index.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'index.html') },
    { id: 'war-static-js-contentint-js', kind: 'web-accessible-resource',
      description: 'Fetch static/js/contentInt.js, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'static/js/contentInt.js') },
  ],
};
